import {defineStore} from 'pinia';
import {useAuth0} from "@auth0/auth0-vue";
import type {Auth0VueClient} from "@auth0/auth0-vue";
import type {Ref} from "vue";
import {User as Auth0User}  from "@auth0/auth0-spa-js";
import type {Project, User} from "@haxo-cz/orders-ts-client";
import {useModuleStore} from "@/stores/moduleStore";

export interface State {
    projects: Project[] | null;
    selectedProject: Project | null;
    user:  Ref<Auth0User | undefined>;
    mongoUser: User | null;
    isAuthenticated: Ref<boolean>,
    auth0:  Auth0VueClient,
}



export const useAppStore = defineStore('appStore', {
    state: (): State => {
        const {isAuthenticated, user, checkSession} = useAuth0();
        return {
            projects: null,
            selectedProject: null,
            user: user,
            mongoUser: null,
            isAuthenticated: isAuthenticated,
            auth0: useAuth0(),
        };
    },
    actions: {
        toUrl(text) {
            return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replaceAll(' ', '-').replaceAll('.', '_').toLowerCase();
        },
        resetStore(){
            this.projects = null;
            this.selectedProject = null;
            this.mongoUser = null;
        },
        login() {
            if (this.auth0) {
                //smazání store
                this.resetStore();
                //přihlášení
                this.auth0.loginWithRedirect();
            }
        },
       async logout() {
            if (this.auth0) {
                // smazání store
                this.resetStore();
                const moduleStore = useModuleStore();
                moduleStore.resetStore();
                //odhlášení
              await this.auth0.logout({
                    logoutParams: {
                        returnTo: window.location.origin,
                    },
                });
            }
        },
    },
    getters: {
        spaces() {
            if (this.projects) {
                const uniqueSpaceMap = new Map();

                // získání spaces
                this.projects.forEach((project) => {
                    const key = project.spaceId + project.spaceName;
                    if (!uniqueSpaceMap.has(key)) {
                        uniqueSpaceMap.set(key, {
                            spaceId: project.spaceId,
                            spaceName: project.spaceName,
                        });
                    }
                });
                // z mapy na array
                return Array.from(uniqueSpaceMap.values());
            }

            return [];
        },
    },
    persist: true,
});

